import React, { Component } from 'react';
import PropTypes from 'prop-types';

import msg from 'msg';

import getRefineByCount from '../utils/getRefinedByCount';

export default class RefineByButton extends Component {
  static propTypes = {
    pageParameters: PropTypes.shape({
      filters: PropTypes.array,
      customFilters: PropTypes.array,
      priceFilters: PropTypes.array,
      cluster: PropTypes.array,
      hiddenOOS: PropTypes.bool,
    }).isRequired,
    onRefineByClick: PropTypes.func.isRequired,
    sortDisplay: PropTypes.bool,
  };

  shouldComponentUpdate(nextProps) {
    return (
      this.props.pageParameters !== nextProps.pageParameters
    );
  }

  render() {
    const { pageParameters, onRefineByClick, sortDisplay } = this.props;
    const refineByCount = getRefineByCount(pageParameters);
    const refineByLabel = refineByCount
      ? `${msg.headerBar.refinedByLabel} (${refineByCount})`
      : msg.headerBar.refinedByLabel;
    const refineByClass = `refine-by btn-tertiary hide-for-xlarge ${sortDisplay ? '' : 'filters-only'}`;
    return (
      <button className={refineByClass} onClick={onRefineByClick}>
        {refineByLabel}
      </button>
    );
  }
}
